var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusiconblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2146",
    "data-name": "Group 2146",
    transform: "translate(-426 -589)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_728",
    "data-name": "Ellipse 728",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(426 589)",
    fill: "#4eb6ee"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_553",
    "data-name": "Line 553",
    x2: 7.894,
    transform: "translate(429.454 595.907)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusiconblue);
export default __webpack_public_path__ + "static/media/minusiconblue.dafa098fc726eefd8b52f946408e775e.svg";
export { ForwardRef as ReactComponent };